<button
  type="button"
  [class]="computedButtonClass"
  [disabled]="disabled"
  [ngStyle]="style"
  (click)="toggle()"
  (blur)="markTouched()"
  >
  @if (currentIcon) {
    <span class="p-button-icon" [ngClass]="[currentIcon, iconPositionClass]"></span>
  }
  <span class="p-button-label">{{ currentLabel }}</span>
</button>

